import { useEffect } from "react";
import PageHeader from "../components/layout/PageHeader";
import OrderForm from "../components/features/OrderForm";
import { setPageMeta, JsonLd, breadcrumbSchema } from "../lib/schema";

export default function OrderPage() {
  useEffect(() => {
    setPageMeta({
      title: "Place an Order | My Private Shopper UK",
      description:
        "Submit your MPS order in three steps. Tell us what you want, share delivery details, and we'll confirm a quote within hours.",
      canonical: "https://privateshopper.co.uk/order",
    });
  }, []);

  return (
    <>
      <JsonLd data={breadcrumbSchema([
        { name: "Home", url: "/" },
        { name: "Order" },
      ])} />
      <PageHeader
        overline="Order"
        title={<>Three steps, then send it to us on <span className="italic text-[#C9A96E]">WhatsApp</span>.</>}
        body="Fill in your order details below. On submit, we'll open WhatsApp with the full summary pre-filled — you tap Send and a concierge takes it from there. No payment is taken at this stage."
      />
      <OrderForm />
    </>
  );
}
